<script setup lang="ts">
import FileReportTable from "@/components/modules/FileReport/FileReportTable.vue";
import type { Report } from "@/types/reports";

defineProps<{
  report: Report;
  isStartApprove: boolean;
}>();

const emit = defineEmits<{
  hideReportView: [];
  approveReport: [];
}>();
</script>

<template>
  <div class="wrapper">
    <div class="report-view">
      <h1 class="report-view__title">
        Отчет по России за {{ report.year }} год
      </h1>
      <FileReportTable :report="report" />
      <div class="report-view__control">
        <ButtonAccentSecondary
          size="large"
          class="report-view__control-button"
          @click="emit('hideReportView')"
        >
          Отмена
        </ButtonAccentSecondary>
        <ButtonAccentPrimary
          size="large"
          class="report-view__control-button"
          :disabled="isStartApprove"
          @click="emit('approveReport')"
        >
          Утвердить
        </ButtonAccentPrimary>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}

.report-view {
  display: flex;
  flex-direction: column;
  gap: 30px;
  border-radius: 10px;
  width: 90%;
  height: 90%;
  background-color: var(--background-bg-white);
  padding: 30px;

  &__control {
    display: flex;
    margin-left: auto;
    gap: 10px;
    margin-top: auto;

    &-button {
      width: 225px;
    }
  }

  &__title {
    color: var(--text-text-black);
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
  }

  &__table {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}

.main-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: min-content;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;

  &__wrapper {
    background-color: var(--background-01);
    padding: 0 10px 10px 10px;
    border-radius: 10px;
    height: 100%;
    overflow: visible;
    box-sizing: border-box;
  }

  &__header {
    position: sticky;
    top: 0;
    z-index: 2;
    flex-shrink: 0;

    &--with-scroll {
      margin-right: 28px;
    }
  }

  &__body {
    position: relative;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--background-bg-white);
  }

  &__row {
    display: grid;
    grid-template-columns: 1200px repeat(12, 90px);
    flex-shrink: 0;
    border-right: 1px solid var(--purple-purple20);

    &--nested {
      grid-template-columns: 1200px repeat(12, 90px);
    }

    &--data:not(:last-child) {
      border-bottom: 1px solid var(--purple-purple20);
    }

    &--with-scroll {
      margin-right: 28px;
    }

    &--header {
      grid-template-columns: 1200px repeat(12, 90px);
      border: none;
    }
  }

  &__col {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 10px 16px;
    background-color: var(--background-bg-white);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &--value {
      text-align: center;
    }

    &--nested {
      padding-left: 40px;
      border-left: 1px solid var(--purple-purple20);
    }

    &--expandable {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &--header {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: var(--text-text-main);
      background-color: var(--background-01);
      margin-top: 10px;
    }
  }
}

.expand-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  flex-shrink: 0;
  transform: rotate(180deg);

  &--nested {
    width: 16px;
    height: 16px;
  }

  &--expanded {
    transform: rotate(0);
  }

  &:hover {
    opacity: 0.7;
  }
}

</style>